<template>
    <div class="login">
        <component :is="loginView"
                   @fnBtnClick='fnBtnClick'
                   @fnGetYilewanToken="fnGetYilewanToken"></component>
        <modal-slot :data="wndThirdLoginData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndThirdLogin">
            <component :is="thirdLogin"
                       @fnGetYilewanToken="fnGetYilewanToken"></component>
        </modal-slot>
    </div>
</template>

<script>
import methods from './methods.vue' //登录方式
import normal from './normal.vue' //账号登录
import phone from './phone.vue' //手机号登录
import register from './register.vue' //注册
import forget from './forget.vue' //忘记密码
import weixin from './weixin.vue' //微信登录
import qq from './qq.vue' //微信登录
import autoreg from './autoreg.vue' //自动注册登录
import ModalSlot from '@/components/ModalSlot'
export default {
    name: 'login',
    props: {
        loginMethod: {
            type: String,
            data: ''
        }
    },
    data () {
        return {
            loginView: '',
            USER: '',
            loginType: 1,
            thirdLogin: 'qq',
            wndThirdLogin: false,
            wndThirdLoginData: {
                title: '第三方账号登录',
                style: {
                    width: '760px',
                    height: '520px',
                    marginLeft: '-380px',
                    marginTop: '-260px'
                },
                visible: true,
                type: 'wndThirdLogin',
                class: 'wndThirdLogin'
            },
            loginType: 1,
            boxLoginStatus: false
        }
    },
    watch: {
        loginMethod (o, n) {
            console.log(o)
            this.fnBtnClick(o)
        }
    },
    components: {
        methods,
        normal,
        phone,
        register,
        forget,
        weixin,
        qq,
        autoreg,
        ModalSlot
    },
    mounted () {
        this.fnBtnClick(this.loginMethod)
        this.fnEventListener()
    },
    methods: {
        fnBtnClick (type) {
            if (typeof type === 'object') {
                if (type.dataType === 'modalSlotClose') {
                    switch (type.dataClose) {
                        case 'wndThirdLogin':
                            this.wndThirdLogin = false
                            break
                    }
                }
            } else {
                this.$emit('fnSwitchLoger', type)
                switch (type) {
                    case 'normal':
                        this.$cookies.set('login_type', 'normal', -1, '/', location.host.substring(location.host.indexOf('.')))
                        this.loginView = 'normal'
                        this.loginType = 1
                        break
                    case 'phone':
                        this.$cookies.set('login_type', 'phone', -1, '/', location.host.substring(location.host.indexOf('.')))
                        this.loginView = 'phone'
                        this.loginType = 2
                        break
                    case 'register':
                        this.$cookies.set('login_type', 'register', -1, '/', location.host.substring(location.host.indexOf('.')))
                        this.loginView = 'register'
                        break
                    case 'forget':
                        this.loginView = 'forget'
                        break
                    case 'weixin':
                        this.$cookies.set('login_type', 'weixin', -1, '/', location.host.substring(location.host.indexOf('.')))
                        this.thirdLogin = 'weixin'
                        this.wndThirdLogin = true
                        this.wndThirdLoginData.title = '微信登录'
                        this.loginType = 5
                        break
                    case 'qq':
                        this.$cookies.set('login_type', 'qq', -1, '/', location.host.substring(location.host.indexOf('.')))
                        this.thirdLogin = 'qq'
                        this.wndThirdLogin = true
                        this.wndThirdLoginData.title = 'QQ登录'
                        this.loginType = 3
                        break
                    case 'methods':
                        this.loginView = 'methods'
                        break
                    case 'autoreg':
                        this.$cookies.set('login_type', 'autoreg', -1, '/', location.host.substring(location.host.indexOf('.')))
                        this.loginView = 'autoreg'
                        this.loginType = 1
                        break
                }
            }
        },
        // 易乐玩token登录
        fnGetYilewanToken (reg) {
            let t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI(
                'ylwtoken',
                {},
                (res) => {
                    if (res.status === 'error') {
                        t.Toast({ content: res.msg })
                        return
                    }
                    let d = res.data
                    if (reg) {
                        d.reg = reg
                    }
                    t.fnBoxLogin(d)
                }
            )
        },
        // 盒子登录
        fnBoxLogin (d, fn) {
            let t = this
            if (fn) {
                t.fn = true
            } else {
                t.fn = false
            }
            t.XHR({
                url: t.ports.user.login,
                data: {
                    yilewan_token: d.token,
                    uid: d.uid
                },
                cbFn (res) {
                    if (res.status === 'error') {
                        t.Toast({
                            content: res.info,
                            time: 5000
                        })
                        return
                    }
                    t.$store.commit('FNSTATE', {
                        USER: res.data
                    })
                    t.Storage.set('USER', res.data, (j) => { })
                    t.USER = res.data
                    // 发送统计
                    t.dsspFn(res.data, d.reg)
                    setTimeout(() => {
                        t.$emit('loginResult', res.data)
                    }, 100)
                }
            })
        },
        dsspFn (data, type) {
            let t = this
            t.DSP.login({
                dataType: 'login',
                uid: data.uid,
                passport: data.passport,
                type: t.loginType,
                login_type: 2
            })
            if (type) {
                t.DSP.login({
                    uid: data.uid,
                    passport: data.passport,
                    login_type: 2
                })
            }
        },
        fnMsgEvent (e) {
            let t = this
            let data = e.data
            if (e && e.data !== 'undefined') {
                data = typeof data === 'string' ? JSON.parse(data) : e.data
            }
            switch (data.type) {
                case 'boxToken':
                    if (t.boxLoginStatus) return
                    t.boxLoginStatus = true
                    t.fnGetYilewanToken(parseInt(t.$cookies.get('isFirst')))
                    t.$cookies.remove('isFirst', '/', '.yilewan.com')
                    break
            }
        },
        // 消息监听
        fnEventListener () {
            window.addEventListener('message', this.fnMsgEvent, false)
        },
    },
    destroyed () {
        window.removeEventListener("message", this.fnMsgEvent, true);
    },
}
</script>

<style lang="less">
</style>
